// Wire-contract list of profile-storable typefaces. The Control UI derives
// its override normalization from this tuple so browser and profile values agree.
export const UI_APPEARANCE_TYPEFACE_VALUES = [
  "instrument-sans",
  "geist",
  "dm-sans",
  "ibm-plex-sans",
  "space-grotesk",
  "atkinson-hyperlegible",
  "fraunces",
  "lora",
  "jetbrains-mono",
  "system",
] as const;
